import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CustomerNotification, CustomerNotificationListRequest, NotificationsResponse } from '~/modules/admin/models/admin.model';

@Injectable({
    providedIn: 'root'
})
export class CustomerNotificationsService {
    private apiUrl = `${environment.apiUrl}InternalData/customer-notifications`;

    constructor(private http: HttpClient) { }

    getTableData(request: CustomerNotificationListRequest): Observable<NotificationsResponse> {
        return this.http.post<NotificationsResponse>(`${this.apiUrl}`, request)
            .pipe(
                catchError(this.handleError)
            );
    }

    updateContactedStatus(notificationId: string, contacted: boolean, userId: string): Observable<CustomerNotification> {
        return this.http.patch<CustomerNotification>(`${this.apiUrl}/${notificationId}`, { contacted, userId })
            .pipe(
                catchError(this.handleError)
            );
    }

    updateComment(notificationId: string, comment: string, userId: string): Observable<CustomerNotification> {
        return this.http.post<CustomerNotification>(`${this.apiUrl}/${notificationId}`, { comment, userId })
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        let errorMessage = 'An unknown error occurred';

        if (error.error instanceof ErrorEvent) {
            // Client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // Server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }

        console.error(errorMessage);
        return throwError(errorMessage);
    }
}
